import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import BeachDetailsHeader from '../beachDetails/BeachDetailsHeader';
import BeachDetailsBody from '../beachDetails/BeachDetailsBody';
import I18n from '../../languages/I18n';

import {getBeachDetails} from '../../redux/actions/beachesActions';

const PanelDetails = props => {
  const dispatch = useDispatch();
  const beach_details = useSelector(state => state.beaches.beach_details);
  const beachId = beach_details ? beach_details.id : null;

  useEffect(() => {
    if (beachId) {
      dispatch(getBeachDetails(beachId, props.language || I18n.locale));
    }
  }, [beachId, dispatch, props.language]);

  if (!beach_details) return null;

  const header = (
    <BeachDetailsHeader
      city={beach_details.city}
      quality={beach_details.quality}
      quality_explanation={beach_details.quality_explanation}
      quality_updated_at={beach_details.quality_updated_at}
      explanation={beach_details.explanation}
      ostreopsis={beach_details.ostreopsis}
      ostreopsis_updated_at={beach_details.ostreopsis_updated_at}
      color={beach_details.color}
      url_img={beach_details.url_img}
      name={beach_details.name}
    />
  );

  const body = (
    <BeachDetailsBody
      description={beach_details.description}
      opening_desc={beach_details.opening_desc}
      demarche_qualite={beach_details.demarche_qualite}
      pavillon_bleu={beach_details.pavillon_bleu}
      more_info={beach_details.more_info}
      service_1={beach_details.service_1}
      service_2={beach_details.service_2}
      service_3={beach_details.service_3}
      service_4={beach_details.service_4}
      service_5={beach_details.service_5}
      service_6={beach_details.service_6}
      service_7={beach_details.service_7}
      service_8={beach_details.service_8}
      service_9={beach_details.service_9}
      service_10={beach_details.service_10}
    />
  );

  if (!props.isSmall) {
    return (
      <>
        <div
          onClick={props.hidePanel}
          style={{
            position: 'absolute',
            top: 27,
            right: 40,
            textAlign: 'center',
            zIndex: 100,
            cursor: 'pointer',
          }}>
          <img src={require('../../assets/icons/ico_remove.png')} style={{ width: 30, height: 30 }} alt="close" />
        </div>

        <div
          className='animatedfast fadeInRight'
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: 500,
            maxWidth: '100%',
            backgroundColor: '#fff',
            height: '100%',
            zIndex: 11,
            overflowY: 'scroll',
            boxSizing: 'border-box',
            boxShadow: '-3px 0px 10px 0px rgba(0,0,0,0.1)',
          }}>
          {header}
          {body}
        </div>
      </>
    );
  }

  return (
    <>
      <div
        onClick={props.hidePanel}
        style={{
          position: 'absolute',
          top: '30%',
          paddingTop: 15,
          right: 15,
          color: '#fff',
          fontSize: 18,
          textAlign: 'center',
          zIndex: 12,
          cursor: 'pointer',
        }}>
        <img src={require('../../assets/icons/ico_remove.png')} style={{ width: 20, height: 20 }} alt="close" />
      </div>

      <div
        className='animatedfast fadeInUp'
        style={{
          position: 'absolute',
          bottom: 0,
          right: 0,
          width: '100%',
          backgroundColor: '#fff',
          height: '70%',
          zIndex: 11,
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
          boxShadow: '0 -10px 30px rgba(0,0,0,0.18)',
          overflowY: 'scroll',
          overflowX: 'hidden',
        }}>
        {header}
        {body}
      </div>
    </>
  );
};

export default PanelDetails;
